module.exports = __webpack_public_path__ + "img/guarantee-privacy.1948d092.png";